export const rdsSetNavMenuHighlight = (activeItemId) => {
  const event = new CustomEvent('rdsSetNavMenuHighlight', {
    detail: {
      activeItemId: activeItemId,
    },
  });

  document.dispatchEvent(event);
};
